<template>
  <b-modal
    v-model="isModalActive"
    has-modal-card
    trap-focus
    scroll="keep"
    :can-cancel="!loading"
  >
    <!-- overflow visible: el calendario no queda recortado -->
    <div class="modal-card" style="width: 640px; max-width: 98vw; overflow: visible;">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ $t('complete_tasks') }}</p>
        <button type="button" class="delete" :disabled="loading" @click="hide" />
      </header>

      <section class="modal-card-body" style="overflow: visible;">
        <div class="text-sm text-blue" v-html="$t('complete_selected_tasks_confirm_text', { count: count })"></div>

        <!-- campo fecha -->
        <div class="flex flex-col mt-4">
          <div class="text-xs font-medium text-blue">{{ $t('date') }}</div>
          <div class="flex flex-row w-full">
            <b-field>
              <b-datepicker
                v-model="form.date"
                title="date"
                name="date"
                :placeholder="$t('date')"
                :required="true"
                class="w-full"
                icon-pack="fas"
                icon="calendar"
                :first-day-of-week="parseInt($t('first_day_of_week'))"
                :max-date="today"
              ></b-datepicker>
            </b-field>
          </div>
        </div>

        <!-- campo observaciones -->
        <div class="flex flex-col">
          <div class="text-xs font-medium text-blue">{{ $t('observations') }}</div>
          <div class="flex flex-row w-full">
            <textarea
              v-model="form.observation"
              title="observation"
              name="observation"
              maxlength="2000"
              :placeholder="$t('observations')"
              class="w-full h-36 p-2 text-xs border rounded bg-grey-lighter border-grey-light"
            />
          </div>
          <p class="mt-1 text-xs text-grey">{{ $t('complete_selected_tasks_bulk_hint') }}</p>
        </div>
      </section>

      <footer class="modal-card-foot justify-end">
        <b-button :disabled="loading" @click="hide">{{ $t('cancel') }}</b-button>
        <b-button
          type="is-success"
          :loading="loading"
          :disabled="!form.date || count === 0"
          @click="onConfirm"
        >
          {{ $t('complete_resource') }}
        </b-button>
      </footer>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: "assignment-bulk-complete-modal",

  props: {
    loading: { type: Boolean, default: false },
  },

  data: () => ({
    isModalActive: false,
    count: 0,
    form: {
      date: null,
      observation: '',
    },
  }),

  computed: {
    today() {
      const today = new Date()
      today.setHours(0, 0, 0, 0)
      return today
    },
  },

  methods: {
    show(count) {
      this.count = count
      this.form = { date: new Date(), observation: '' }
      this.isModalActive = true
    },

    hide() {
      if (this.loading) return
      this.isModalActive = false
    },

    close() {
      this.isModalActive = false
    },

    onConfirm() {
      if (!this.form.date) return
      const observation = (this.form.observation || '').trim()
      this.$emit('confirm', {
        date: this.processDate(this.form.date),
        observation: observation !== '' ? observation : null,
      })
    },

    processDate(date) {
      // fecha local, sin pasar a UTC
      if (!date) return ''
      const d = new Date(date)
      const year = d.getFullYear()
      const month = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
  },
};
</script>
